import { render } from "./CarouselFotos.vue?vue&type=template&id=7f24b473"
import script from "./CarouselFotos.vue?vue&type=script&lang=js"
export * from "./CarouselFotos.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__